module.exports = __webpack_public_path__ + "fonts/Inter-SemiBoldItalic.1c70752.woff";